
import { InventoryItem, StockStatus } from '../types';

export const inventoryData: InventoryItem[] = [
  {
    id: '1',
    itemNumber: 'ITM-001-A',
    itemName: 'Industrial Ball Bearing X200',
    supplier: 'Supplier Portal',
    currentStock: 450,
    minStock: 100,
    status: StockStatus.HEALTHY,
    category: 'Hardware',
    lastUpdated: '2025-10-24T10:00:00Z'
  },
  {
    id: '2',
    itemNumber: 'ITM-002-B',
    itemName: 'Hydraulic Seal 50mm',
    supplier: 'Sealant Pro AG',
    currentStock: 20,
    minStock: 50,
    status: StockStatus.CRITICAL,
    category: 'Hydraulics',
    lastUpdated: '2025-10-23T14:30:00Z'
  },
  {
    id: '3',
    itemNumber: 'ITM-003-C',
    itemName: 'Control Module V4',
    supplier: 'ElectroHub Inc.',
    currentStock: 55,
    minStock: 50,
    status: StockStatus.WARNING,
    category: 'Electronics',
    lastUpdated: '2025-10-24T09:15:00Z'
  },
  {
    id: '4',
    itemNumber: 'ITM-004-D',
    itemName: 'Steel Fastener M12',
    supplier: 'MetalWorks Ltd.',
    currentStock: 2000,
    minStock: 500,
    status: StockStatus.HEALTHY,
    category: 'Hardware',
    lastUpdated: '2025-10-22T16:45:00Z'
  },
  {
    id: '5',
    itemNumber: 'ITM-005-E',
    itemName: 'Lubricant Synthetic 5L',
    supplier: 'ChemCo Systems',
    currentStock: 15,
    minStock: 40,
    status: StockStatus.CRITICAL,
    category: 'Consumables',
    lastUpdated: '2025-10-24T11:20:00Z'
  },
  {
    id: '6',
    itemNumber: 'ITM-006-F',
    itemName: 'Safety Valve Type-Z',
    supplier: 'SafetyFirst Corp',
    currentStock: 80,
    minStock: 60,
    status: StockStatus.HEALTHY,
    category: 'Safety',
    lastUpdated: '2025-10-21T08:00:00Z'
  },
  {
    id: '7',
    itemNumber: 'ITM-007-G',
    itemName: 'Pressure Sensor 10bar',
    supplier: 'ElectroHub Inc.',
    currentStock: 42,
    minStock: 40,
    status: StockStatus.WARNING,
    category: 'Electronics',
    lastUpdated: '2025-10-24T13:10:00Z'
  },
  {
    id: '8',
    itemNumber: 'ITM-008-H',
    itemName: 'Gasket Kit Series 5',
    supplier: 'Sealant Pro AG',
    currentStock: 120,
    minStock: 30,
    status: StockStatus.HEALTHY,
    category: 'Hydraulics',
    lastUpdated: '2025-10-20T15:00:00Z'
  },
  {
    id: '9',
    itemNumber: 'ITM-009-I',
    itemName: 'Conveyor Belt segment',
    supplier: 'Supplier Portal',
    currentStock: 5,
    minStock: 10,
    status: StockStatus.CRITICAL,
    category: 'Logistics',
    lastUpdated: '2025-10-24T09:00:00Z'
  },
  {
    id: '10',
    itemNumber: 'ITM-010-J',
    itemName: 'Packing Foam Roll',
    supplier: 'PackIt All',
    currentStock: 300,
    minStock: 100,
    status: StockStatus.HEALTHY,
    category: 'Consumables',
    lastUpdated: '2025-10-19T10:00:00Z'
  }
];
